import axios, { AxiosResponse } from "axios";
import { get } from "lodash";
import { FormattedOdds } from "../../interfaces/utils";
import { FormMediafile } from "./interfaces";

export const getMediaFilesIDs = async (
  media: FormMediafile[]
): Promise<string[]> => {
  const getMediaFileId = async (
    file: File,
    fileType: string
  ): Promise<AxiosResponse<string>> => {
    const MediaFormData = new FormData();
    MediaFormData.append("content", file);
    MediaFormData.append("type", fileType);

    return uploadFile(MediaFormData);
  };

  const uploadFile = async (
    mediaFormData: FormData
  ): Promise<AxiosResponse<string>> => {
    return axios.post(`/v1/files`, mediaFormData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  };

  const getTypeFromFileType = (fileType: string): string =>
    fileType.slice(0, fileType.indexOf("/")).toUpperCase();

  return media.reduce(async (previous, file): Promise<string[]> => {
    try {
      const id = await getMediaFileId(
        file.file,
        getTypeFromFileType(file.type)
      );

      const parsedId = get(id, ["media_file", "id"]);
      parsedId && (await previous).push(String(parsedId));

      return [...(await previous)];
    } catch (e: any) {
      return Promise.reject(e);
    }
  }, Promise.resolve<string[]>([]));
};

export const getISODate = (startDate: Date, startTime: string): Date => {
  const [day, month, year] = startDate
      .toLocaleDateString("es-UE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .split("/"),
    [hours, min] = startTime.split(":");

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(min),
    0
  );
};
export const formatRate = (formatted_odds: FormattedOdds) => {
  return parseFloat(parseFloat(formatted_odds.decimal).toFixed(3));
};
